module.exports = __webpack_public_path__ + "img/math-8-en.4b9dc86f.png";